import { SVGProps } from 'react'

const PlaySVG = ({ color = '#fff', ...props }: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      opacity=".7">
      <g>
        <g>
          <g transform="translate(-680 -426) translate(416 250) translate(264 176)">
            <g>
              <path d="M0 0H53.333V53.333H0z" transform="translate(14.545 14.545)" />
              <g fill={color} fillRule="nonzero">
                <path
                  d="M4.299.58l29.375 20.723c1.135.869 1.135 2.39 0 3.26L4.299 45.376c-1.646 1.254-4.252.257-4.252-1.63V2.205C.053.324 2.653-.679 4.299.581z"
                  transform="translate(14.545 14.545) translate(12.121 2.424)" />
              </g>
            </g>
            <circle cx="40" cy="40" r="39.25" stroke={color} strokeWidth="1.5" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default PlaySVG
